<!--
  ~ Copyright (c) Worldline 2022.
  -->

<!DOCTYPE html>
<div *ngIf="askCookieAgreement()" role="cookie-agreement">
    {{ 'cookie.agreement.usecase' | translate }}
    {{ 'cookie.agreement.refusal.before' | translate }} <a
        (click)="refuseCookieAgreement()" id="discardCookies">{{
    'cookie.agreement.refusal.link' |
        translate }}</a>{{ 'cookie.agreement.refusal.after' | translate }}
    <span *ngIf="hasLearnMore()"><a href="{{ getLearnMoreLink() }}">{{ 'cookie.agreement.learnmore' | translate }}</a></span>
    <a (click)="closeCookieAgreementPanel()" id="closePanel">{{
        'cookie.agreement.close' | translate }} x</a>
</div>